<table [class]="tableClass">
  <thead>
    @if(headerTemplate){ 
      <ng-template [ngTemplateOutlet]="headerTemplate"
      [ngTemplateOutletContext]="{ columns: columns }">
    </ng-template>
    }
  </thead>
  <tbody>
    @for(row of rows; track row; let index = $index){
    <ng-container>
      @if(bodyTemplate){
        <ng-template [ngTemplateOutlet]="bodyTemplate"
        [ngTemplateOutletContext]="{ row: row, rowIndex: index }">
      </ng-template>
      }
      @if(bodyDetailTemplate && row.rowDetail?.enabled){
        <ng-template [ngTemplateOutlet]="bodyDetailTemplate"
        [ngTemplateOutletContext]="{ data: row.rowDetail, row }">
      </ng-template>
      }
    </ng-container>
    }
    @if(noDataTemplate && rows && rows.length === 0){
      <ng-template [ngTemplateOutlet]="noDataTemplate">
    </ng-template>
    }
  </tbody>
</table>